import type { AffineThemeV2 } from './light';

export const darkThemeV2: AffineThemeV2 = {
  'aI/applyBackground': '#9292921a',
  'aI/applyDeleteHighlight': '#ed3f3f3b',
  'aI/applyTextHighlight': '#29a3fa',
  'aI/applyTextHighlightBackground': '#1e96eb1a',
  'aI/errorBackground': '#ed3f3f2e',
  'aI/errorDetailBackground': '#00000054',
  'aI/errorText': '#fff4f5',
  'aI/thinkingOutputBackground': '#000000',
  'aI/thinkingOutputText': '#ffffff8f',
  'aI/userTextBackground': '#252525',
  'adjustmentHandle/background': '#00000085',
  'adjustmentHandle/border': '#ffffff',
  'backlinks/blockBackgroundColor': '#9292921a',
  'backlinks/blockBorder': '#9292922b',
  'backlinks/blockHover': '#9292922b',
  'badge/believer': '#002742',
  'badge/free': '#29a3fa',
  'badge/pro': '#29a3fa',
  'block/callout/background/blue': '#002742',
  'block/callout/background/green': '#192e06',
  'block/callout/background/grey': '#414141',
  'block/callout/background/magenta': '#5f0a35',
  'block/callout/background/orange': '#451a02',
  'block/callout/background/purple': '#1e1b4b',
  'block/callout/background/red': '#460606',
  'block/callout/background/teal': '#0e4841',
  'block/callout/background/yellow': '#321a04',
  'block/callout/icon/blue': '#2f94d5',
  'block/callout/icon/green': '#22bf07',
  'block/callout/icon/grey': '#cdcdcd',
  'block/callout/icon/magenta': '#cc4187',
  'block/callout/icon/orange': '#d97705',
  'block/callout/icon/purple': '#7c3aed',
  'block/callout/icon/red': '#c83030',
  'block/callout/icon/teal': '#5cc7ba',
  'block/callout/icon/yellow': '#e0aa00',
  'block/code/background': '#1f2022',
  'block/code/lineNum': '#7a7a7a',
  'block/comment/hanelActive': '#ffffff0d',
  'block/comment/highlightActive': '#1e96eb4d',
  'block/comment/highlightDefault': '#1e96eb14',
  'block/comment/highlightUnderline': '#1e96ebb2',
  'block/divider/divider': '#9292922b',
  'block/footnote/numberBg': '#565656',
  'block/footnote/numberBgHover': '#1e96eb',
  'block/list/header': '#4ab1fa',
  'block/notSupportedBlock/background': '#000000',
  'block/notSupportedBlock/inlineBg/default': '#252525',
  'block/notSupportedBlock/inlineBg/hover': '#414141',
  'block/quote/bar': '#8e8d91',
  'block/recordBlock/buttonBg': '#761717',
  'block/recordBlock/primary': '#f45353',
  'block/recordBlock/secordary': '#c83030',
  'block/recordBlock/timelineIndeicator': '#ed3f3f',
  'brand/primary': '#1e96eb',
  'brand/primaryTint': '#3474ad1a',
  'brand/secondary': '#9096f5',
  'button/actionActive': '#ffffff0d',
  'button/badgesColor': '#c83030',
  'button/buttonOverHover': '#414141',
  'button/checkBox': '#1e96eb',
  'button/disable': '#7a7a7a',
  'button/emptyIconBackground': '#ffffff0d',
  'button/error': '#c83030',
  'button/iconButtonSolid': '#ffffff17',
  'button/innerBlackBorder': '#ffffff0d',
  'button/primary': '#1e96eb',
  'button/pureWhiteText': '#ffffff',
  'button/secondary': '#ffffff17',
  'button/success': '#1d9c07',
  'button/templateLabelBackground': '#1e96eb14',
  'button/grabber/select': '#ffffff21',
  'button/grabber/default': '#ffffff17',
  'button/mobile/aIActionBackground': '#252525',
  'button/mobile/deletedAction': '#c83030',
  'button/sidebarButton/background': '#ffffff08',
  'button/siderbarPrimary/background': '#0000002b',
  'button/signinbutton/background': '#414141',
  'button/windowsClose': '#c42b1c',
  'calendar/blue': '#29a3fa',
  'calendar/green': '#3cbc36',
  'calendar/grey': '#929292',
  'calendar/magenta': '#e660a4',
  'calendar/orange': '#ff8c38',
  'calendar/purple': '#6e52df',
  'calendar/red': '#ed3f3f',
  'calendar/teal': '#5cc7ba',
  'calendar/yellow': '#facc15',
  'centerPeek/background': '#000000',
  'centerPeek/buttonBackground': '#252525',
  'centerPeek/icon': '#cdcdcd',
  'centerPeek/overlay': '#00000085',
  'chatBlock/chatBlockBg': '#252525',
  'chatBlock/chatBlockBoder': '#414141',
  'chatBlock/chatBlockIcon': '#cdcdcd',
  'chatBlock/chatBlockText': '#e6e6e6',
  // Saturated status chips with white labels, identical in every theme.
  'chip/label/blue': '#2563eb',
  'chip/label/green': '#22c55e',
  'chip/label/grey': '#475569',
  'chip/label/magenta': '#c026d3',
  'chip/label/orange': '#f97316',
  'chip/label/purple': '#7c3aed',
  'chip/label/red': '#ef4444',
  'chip/label/teal': '#14b8a6',
  'chip/label/text': '#ffffff',
  'chip/label/white': '#e5e7eb',
  'chip/label/yellow': '#eab308',
  'chip/tag/blue': '#84cfff',
  'chip/tag/green': '#69b87d',
  'chip/tag/grey': '#b3b3b3',
  'chip/tag/orange': '#ff8c38',
  'chip/tag/purple': '#7c3aed',
  'chip/tag/red': '#ed3f3f',
  'chip/tag/teal': '#8be7dc',
  'chip/tag/yellow': '#facc15',
  'database/border': '#ffffff21',
  'database/buttonBackground': '#414141',
  'database/cardHover': '#ffffff08',
  'database/filterHeaderFadeIn': '#000000',
  'database/filterHeaderFadeOut': '#00000008',
  'database/focusBackground': '#1e96eb0a',
  'database/textSecondary': '#ffffff8f',
  'database/attachment/fileSolidBackground': '#414141',
  'dialog/background/primary': '#252525',
  'edgeless/alignment/edgeGuides': '#e660a4',
  'edgeless/alignment/guides': '#8b5cf6',
  'edgeless/axis': '#ffffff40',
  'edgeless/canvas': '#1b1e1a',
  'edgeless/frame/background/black': '#cdcdcd',
  'edgeless/frame/background/blue': '#e6f5ff',
  'edgeless/frame/background/green': '#f1fdf4',
  'edgeless/frame/background/grey': '#f3f3f3',
  'edgeless/frame/background/magenta': '#ffecf6',
  'edgeless/frame/background/orange': '#ffebd5',
  'edgeless/frame/background/purple': '#ede9ff',
  'edgeless/frame/background/red': '#fce5e6',
  'edgeless/frame/background/teal': '#e2fdf9',
  'edgeless/frame/background/white': '#ffffff',
  'edgeless/frame/background/yellow': '#fffbd5',
  'edgeless/frame/border/active': '#1e96eb',
  'edgeless/frame/border/default': '#ffffff2b',
  'edgeless/frame/fontColor/font': '#000000f2',
  'edgeless/grid': '#393a3c',
  'edgeless/gridBlock': '#ffffff12',
  'edgeless/gridCell': '#ffffff0a',
  'edgeless/gridSector': '#ffffff1c',
  'edgeless/group/background/background': '#ffffff',
  'edgeless/group/border/active': '#1e96eb',
  'edgeless/group/border/borderHint': '#8fd1ff',
  'edgeless/group/border/hover': '#1e96eb',
  'edgeless/group/fontColor/active': '#1e96eb',
  'edgeless/group/fontColor/default': '#ffffff8f',
  'edgeless/group/fontColor/hover': '#1e96eb',
  'edgeless/group/fontColor/rename': '#000000',
  'edgeless/line/black': '#000000',
  'edgeless/line/blue': '#29a3fa',
  'edgeless/line/green': '#3cbc36',
  'edgeless/line/grey': '#929292',
  'edgeless/line/magenta': '#e660a4',
  'edgeless/line/orange': '#ff8c38',
  'edgeless/line/purple': '#6e52df',
  'edgeless/line/red': '#ed3f3f',
  'edgeless/line/teal': '#5cc7ba',
  'edgeless/line/white': '#ffffff',
  'edgeless/line/yellow': '#facc15',
  'edgeless/lock/locked': '#92929285',
  'edgeless/mindMap/line': '#ffffff',
  'edgeless/note/black': '#252525',
  'edgeless/note/blue': '#004b7b',
  'edgeless/note/green': '#3b5315',
  'edgeless/note/grey': '#565656',
  'edgeless/note/magenta': '#5f0a35',
  'edgeless/note/orange': '#843b06',
  'edgeless/note/purple': '#312e81',
  'edgeless/note/red': '#460606',
  'edgeless/note/teal': '#0e4841',
  'edgeless/note/white': '#252525',
  'edgeless/note/yellow': '#704200',
  'edgeless/outside': '#111214',
  'edgeless/palette/black': '#ffffff',
  'edgeless/palette/white': '#000000',
  'edgeless/palette/heavy/blue': '#1c70a5',
  'edgeless/palette/heavy/green': '#447756',
  'edgeless/palette/heavy/magenta': '#941555',
  'edgeless/palette/heavy/orange': '#b55309',
  'edgeless/palette/heavy/purple': '#5a21b6',
  'edgeless/palette/heavy/red': '#761717',
  'edgeless/palette/heavy/yellow': '#ac7400',
  'edgeless/palette/light/blueLight': '#e6f5ff',
  'edgeless/palette/light/greenLight': '#f1fdf4',
  'edgeless/palette/light/greyLight': '#e6e6e6',
  'edgeless/palette/light/magentaLight': '#ffecf6',
  'edgeless/palette/light/orangeLight': '#ffebd5',
  'edgeless/palette/light/purpleLight': '#d7cdff',
  'edgeless/palette/light/redLight': '#fce5e6',
  'edgeless/palette/light/yellowLight': '#fffbd5',
  'edgeless/palette/medium/blueMedium': '#84cfff',
  'edgeless/palette/medium/greenMedium': '#3cbc36',
  'edgeless/palette/medium/greyMedium': '#929292',
  'edgeless/palette/medium/magentaMedium': '#e96cab',
  'edgeless/palette/medium/orangeMedium': '#ff8c38',
  'edgeless/palette/medium/purpleMedium': '#6e52df',
  'edgeless/palette/medium/redMedium': '#fb7081',
  'edgeless/palette/medium/yellowMedium': '#fcd34d',
  'edgeless/selection/selectionMarqueeBackground': '#1e96eb14',
  'edgeless/selection/selectionMarqueeBorder': '#1e96eb',
  'edgeless/shape/black': '#000000',
  'edgeless/shape/blue': '#9fd9ff',
  'edgeless/shape/green': '#9bda91',
  'edgeless/shape/grey': '#cdcdcd',
  'edgeless/shape/magenta': '#ffc0e0',
  'edgeless/shape/orange': '#ffae63',
  'edgeless/shape/purple': '#d7cdff',
  'edgeless/shape/red': '#fbb7b7',
  'edgeless/shape/teal': '#8be7dc',
  'edgeless/shape/white': '#ffffff',
  'edgeless/shape/yellow': '#fde047',
  'edgelessToolbar/highlightPen/body': '#3d3d3d',
  'edgelessToolbar/highlightPen/body1Linear1-1': '#00000000',
  'edgelessToolbar/highlightPen/body1Linear1-2': '#00000000',
  'edgelessToolbar/highlightPen/body1Linear1-3': '#000000',
  'edgelessToolbar/highlightPen/body1Linear2-1': '#00000000',
  'edgelessToolbar/highlightPen/body1Linear2-2': '#00000080',
  'edgelessToolbar/highlightPen/body1Linear2-3': '#000000',
  'edgelessToolbar/highlightPen/body1Linear2-4': '#ffffff',
  'edgelessToolbar/highlightPen/body2': '#303030',
  'edgelessToolbar/highlightPen/body2Linear1-1': '#00000000',
  'edgelessToolbar/highlightPen/body2Linear1-2': '#00000000',
  'edgelessToolbar/highlightPen/body2Linear1-3': '#00000000',
  'edgelessToolbar/highlightPen/body2Linear2-1': '#00000000',
  'edgelessToolbar/highlightPen/body2Linear2-2': '#00000000',
  'edgelessToolbar/highlightPen/body2Linear2-3': '#00000000',
  'edgelessToolbar/highlightPen/body2Linear2-4': '#000000',
  'edgelessToolbar/highlightPen/body2Linear2-5': '#797979',
  'edgelessToolbar/highlightPen/bodyColorLinear-1': '#00000000',
  'edgelessToolbar/highlightPen/bodyColorLinear-2': '#000000',
  'edgelessToolbar/highlightPen/bodyColorLinear-3': '#000000c4',
  'edgelessToolbar/media/whiteVector': '#00000038',
  'edgelessToolbar/note/background': '#414141',
  'edgelessToolbar/note/textColor': '#ffffff21',
  'edgelessToolbar/others/background': '#4a4a4ab2',
  'edgelessToolbar/others/highlightLinearEnd': '#ffffff1f',
  'edgelessToolbar/others/highlightLinearStart': '#ffffff0f',
  'edgelessToolbar/others/linearCenter': '#000000a8',
  'edgelessToolbar/others/linearEnd': '#00000000',
  'edgelessToolbar/others/linearStart': '#00000000',
  'edgelessToolbar/penEraser/eraserBlue-1': '#1c3d5d',
  'edgelessToolbar/penEraser/eraserBlue-2': '#a1c5d3',
  'edgelessToolbar/penEraser/eraserBlue-3': '#1a7cc1',
  'edgelessToolbar/penEraser/eraserBodyFill': '#3d3d3d',
  'edgelessToolbar/penEraser/eraserBodyHighlight': '#ffffff17',
  'edgelessToolbar/penEraser/eraserBodyShade2': '#000000cc',
  'edgelessToolbar/penEraser/eraserBodyShade3': '#ffffff66',
  'edgelessToolbar/penEraser/eraserBorder': '#7f7f7f',
  'edgelessToolbar/penEraser/eraserBorder2': '#9b9b9b',
  'edgelessToolbar/penEraser/eraserClothHighlight': '#ffffff1c',
  'edgelessToolbar/penEraser/eraserClothShade2': '#0f0f0f',
  'edgelessToolbar/penEraser/eraserClothShade3': '#ffffff17',
  'edgelessToolbar/penEraser/eraserShadow': '#000000c4',
  'edgelessToolbar/penEraser/penBackground': '#3d3d3d',
  'edgelessToolbar/penEraser/penBodyShade-1': '#00000099',
  'edgelessToolbar/penEraser/penBodyShade-2': '#00000066',
  'edgelessToolbar/penEraser/penBodyShade-3': '#00000033',
  'edgelessToolbar/penEraser/penBodyShade-4': '#0000001a',
  'edgelessToolbar/penEraser/penInlineShadow': '#00000040',
  'icon/activated': '#1e96eb',
  'icon/disable': '#414141',
  'icon/fileIconBorder': '#565656',
  'icon/monotone': '#7a7a7a',
  'icon/primary': '#f3f3f3',
  'icon/secondary': '#cdcdcd',
  'icon/tertiary': '#565656',
  'icon/transparentBlack': '#ffffffb8',
  'icon/fileIconColors/blue': '#0077cb',
  'icon/fileIconColors/green': '#1d9c07',
  'icon/fileIconColors/grey': '#312e81',
  'icon/fileIconColors/magenta': '#e660a4',
  'icon/fileIconColors/purple': '#6e52df',
  'icon/fileIconColors/red': '#ed3f3f',
  'icon/fileIconColors/yellow': '#facc15',
  'input/background': '#ffffff17',
  'input/scrollBar/handle': '#ffffff2b',
  'input/border/active': '#1e96eb',
  'input/border/default': '#ffffff66',
  'input/border/error': '#ed3f3f',
  'integrations/background/iconSolid': '#ffffff',
  'layer/background/hoverFilled': '#2a2a2a',
  'layer/black': '#ffffff',
  'layer/blackAlpha/10': '#ffffff1a',
  'layer/blackAlpha/30': '#ffffff4d',
  'layer/blackAlpha/50': '#ffffff80',
  'layer/blackAlpha/60': '#ffffff99',
  'layer/blackAlpha/80': '#ffffffcc',
  'layer/blackAlpha/90': '#ffffffe6',
  'layer/pureBlack': '#000000',
  'layer/pureWhite': '#ffffff',
  'layer/white': '#000000',
  'layer/insideBorder/blackBorder': '#ffffff66',
  'layer/insideBorder/border': '#ffffff26',
  'layer/insideBorder/primaryBorder': '#1e96eb',
  'layer/insideBorder/splitviewActived': '#ffffffab',
  'layer/insideBorder/whiteBorder': '#ffffff0d',
  'layer/background/appChrome': '#171a16',
  'layer/background/codeBlock': '#252525',
  'layer/background/edgelessGrid': '#565656',
  'layer/background/error': '#460606',
  'layer/background/hoverOverlay': '#ffffff17',
  'layer/background/selected': '#ffffff29',
  'layer/background/linkedDocOnEdgeless': '#252525',
  'layer/background/modal': '#00000099',
  'layer/background/modalWhite': '#ffffff2b',
  'layer/background/overlayPanel': '#23271f',
  'layer/background/primary': '#1F231E',
  'layer/background/processing': '#002742',
  'layer/background/secondary': '#2b3029',
  'layer/background/success': '#1c3027',
  'layer/background/tertiary': '#52584f',
  'layer/background/translucentUI': '#000000a6',
  'layer/background/warning': '#321a04',
  'layer/background/mobile/iOSControl': '#ffffff',
  'layer/background/mobile/modal': '#00000085',
  'layer/background/mobile/primary': '#000000',
  'layer/background/mobile/secondary': '#252525',
  'layer/background/mobile/tertiary': '#414141',
  'layer/whiteAlpha/10': '#0000001a',
  'layer/whiteAlpha/30': '#0000004d',
  'layer/whiteAlpha/50': '#00000080',
  'layer/whiteAlpha/60': '#00000099',
  'layer/whiteAlpha/80': '#000000cc',
  'layer/whiteAlpha/90': '#000000e6',
  'loading/background': '#ffffff2b',
  'loading/backgroundLayer': '#929292f2',
  'loading/foreground': '#0077cb',
  'loading/imageLoadingBackground': '#92929238',
  'loading/imageLoadingLayer': '#ffffff8f',
  'others/warnLabel/black': '#000000',
  'others/warnLabel/yellow': '#facc15',
  'pagelist/hoverBorder': '#7a7a7a',
  'portrait/localPortrait': '#ffffff3b',
  'portrait/localPortraitBackground': '#ffffff2b',
  'radio/disable': '#7a7a7a',
  'radio/active/chekced': '#1e96eb',
  'radio/active/default': '#b3b3b3',
  'readwise/quoteBackground': '#252525',
  'readwise/quoteDivider': '#1e96eb',
  'segment/background': '#ffffff0d',
  'segment/button': '#ffffff17',
  'selfhost/portrait/localPortraitBackground': '#ffffff21',
  'selfhost/button/disable': '#252525',
  'selfhost/button/primary': '#f3f3f3',
  'selfhost/button/secondary': '#ffffff17',
  'selfhost/button/sidebarButton/bg/hover': '#ffffff17',
  'selfhost/button/sidebarButton/bg/select': '#ffffff17',
  'selfhost/icon/buttonIcon': '#141414',
  'selfhost/icon/buttonIconError': '#ffffff',
  'selfhost/icon/disable': '#565656',
  'selfhost/icon/primary': '#f3f3f3',
  'selfhost/icon/secondary': '#cdcdcd',
  'selfhost/icon/tertiary': '#565656',
  'selfhost/layer/background/hoverOverlay': '#fffffffa',
  'selfhost/layer/background/primary': '#1F231E',
  'selfhost/layer/background/secondary': '#252525',
  'selfhost/layer/background/sidebarBg/sidebarBg': '#252525',
  'selfhost/layer/border/border': '#e6e6e6',
  'selfhost/progress/error': '#c83030',
  'selfhost/progress/primary': '#e6e6e6',
  'selfhost/text/placeholder': '#7a7a7a',
  'selfhost/text/button/error': '#ffffff',
  'selfhost/text/button/primary': '#141414',
  'selfhost/text/sidebar/primary': '#e6e6e6',
  'selfhost/text/sidebar/secondary': '#cdcdcd',
  'selfhost/toggle/backgroundDisable': '#414141',
  'selfhost/toggle/backgroundOff': '#565656',
  'selfhost/toggle/backgroundOn': '#b3b3b3',
  'selfhost/toggle/foreground': '#fffffffa',
  'selfhost/toggle/foregroundDisable': '#565656',
  'shadow/active': '0px 0px 0px 2px rgba(28, 158, 228, 0.30)',
  'shadow/button':
    '0px 0px 1px 0px rgba(0, 0, 0, 0.20), 0px 1px 5px 0px rgba(0, 0, 0, 0.20)',
  'shadow/floatButton':
    '0px 0px 10px rgba(0, 0, 0, 0.05), 0px 0px 0px 0.5px rgba(0, 0, 0, 0.1)',
  'shadow/largeButton': '0px 12px 20px 4px rgba(28, 158, 228, 0.18)',
  'shadow/level1': '0px 0px 4px 0px rgba(0, 0, 0, 0.24)',
  'shadow/level2': '0px 0px 12px 0px rgba(0, 0, 0, 0.28)',
  'shadow/level3': '0px 0px 20px 0px rgba(0, 0, 0, 0.32)',
  'shadow/menu':
    '0px 10px 18px rgba(0,0,0,0.14), 0px -1px 12px rgba(0,0,0,0.08)',
  'shadow/note/box':
    '0px 0px 2px 0px rgba(255, 255, 255, 0.44), 0px 2px 12px 0px rgba(0, 0, 0, 0.30)',
  'shadow/note/film': '10px 10px 0px 6px #7A7A7A, 0px 0px 0px 6px #7A7A7A',
  'shadow/note/float':
    '0px 0px 32px 0px rgba(0, 0, 0, 0.30), 0px 0px 2px 0px rgba(255, 255, 255, 0.44)',
  'shadow/note/paper':
    '0px 2px 4px 0px rgba(0, 0, 0, 0.30), 0px 0px 10px #7A7A7A, 0px 6px 12px rgba(0, 0, 0, 0.40)',
  'shadow/note/sticker':
    '0px 24px 26px -10px rgba(0, 0, 0, 0.22), 0px 26px 18px -18px rgba(0, 0, 0, 0.52)',
  'shadow/overlay':
    '0px 1px 6px 0px rgba(0, 0, 0, 0.72), 0px 8px 14px 0px rgba(0, 0, 0, 0.32)',
  'shadow/overlayPanel':
    '0px 1px 6px rgba(0,0,0,0.2), 0px 8px 14px rgba(0,0,0,0.3)',
  'shadow/popover':
    '0px 0px 30px 0px rgba(0, 0, 0, 0.1), 0px 0px 8px 0px rgba(0, 0, 0, 0.18), 0px 0px 0px 0.5px rgba(48, 48, 48, 1) inset',
  'shadow/toolbar': '0px 6px 18px #00000052',
  'skeleton/skeleton': '#252525',
  'slashMenu/background': '#252525',
  'status/error': '#c83030',
  'status/processing': '#1f5ecc',
  'status/success': '#1d9c07',
  'status/warning': '#bc362a',
  'switch/buttonBackground/active': '#414141',
  'switch/buttonBackground/hover': '#ffffff0d',
  'switch/fontColor/primary': '#e6e6e6',
  'switch/fontColor/secondary': '#929292',
  'switch/fontColor/tertiary': '#7a7a7a',
  'switch/iconColor/active': '#cdcdcd',
  'switch/iconColor/default': '#7a7a7a',
  'switch/switchBackground/background': '#252525',
  'tab/divider/divider': '#ffffff21',
  'tab/divider/indicator': '#1e96eb',
  'tab/fontColor/active': '#e6e6e6',
  'tab/fontColor/default': '#565656',
  'tab/fontColor/hover': '#e6e6e6',
  'tab/iconColor/active': '#cdcdcd',
  'tab/iconColor/default': '#7a7a7a',
  'tab/iconColor/hover': '#cdcdcd',
  'tab/tabBackground/active': '#414141',
  'tab/tabBackground/default': '#252525',
  'tab/tabBackground/hover': '#252525',
  'table/border': '#ffffff21',
  'table/focusBackground': '#1e96eb0a',
  'table/focusBorder': '#1e96eb',
  'table/textSecondary': '#ffffff8f',
  'table/headerBackground/blue': '#004b7b',
  'table/headerBackground/default': '#252525',
  'table/headerBackground/green': '#10340a',
  'table/headerBackground/grey': '#565656',
  'table/headerBackground/headerColor': '#252525',
  'table/headerBackground/orange': '#843b06',
  'table/headerBackground/purple': '#25136d',
  'table/headerBackground/red': '#460606',
  'table/headerBackground/teal': '#0e4841',
  'table/headerBackground/yellow': '#704200',
  'table/indicator/activated': '#1e96eb',
  'table/indicator/border': '#414141',
  'table/indicator/drag': '#ffffff21',
  'table/indicator/hover': '#ffffff17',
  'table/indicator/pointerActive': '#ffffff',
  'table/indicator/pointerDefault': '#cdcdcd',
  'text/disable': '#565656',
  'text/emphasis': '#29a3fa',
  'text/link': '#7ac8ff',
  'text/listDotAndNumber': '#4ab1fa',
  'text/placeholder': '#a0a0a0',
  'text/primary': '#e6e6e6',
  'text/pureWhite': '#ffffff',
  'text/secondary': '#b4b4b4',
  'text/tertiary': '#a0a0a0',
  'text/highlight/border': '#ffffff3b',
  'text/highlight/bg/blue': '#002742',
  'text/highlight/bg/green': '#192e06',
  'text/highlight/bg/grey': '#414141',
  'text/highlight/bg/magenta': '#5f0a35',
  'text/highlight/bg/orange': '#843b06',
  'text/highlight/bg/purple': '#2e1065',
  'text/highlight/bg/red': '#460606',
  'text/highlight/bg/teal': '#0e4841',
  'text/highlight/bg/yellow': '#321a04',
  'text/highlight/fg/blue': '#2f94d5',
  'text/highlight/fg/green': '#9bda91',
  'text/highlight/fg/grey': '#565656',
  'text/highlight/fg/magenta': '#f37fba',
  'text/highlight/fg/orange': '#ffae63',
  'text/highlight/fg/purple': '#9681ef',
  'text/highlight/fg/red': '#fc7979',
  'text/highlight/fg/teal': '#448e86',
  'text/highlight/fg/yellow': '#facc15',
  'toast/cardLayer/second': '#252525',
  'toast/cardLayer/third': '#252525',
  'toast/iconState/error': '#c83030',
  'toast/iconState/regular': '#035f9f',
  'toast/iconState/success': '#1d9c07',
  'toast/overlay/secondary': '#0000000d',
  'toast/overlay/tertiary': '#00000008',
  'toggle/background': '#0077cb',
  'toggle/backgroundDisable': '#414141',
  'toggle/backgroundOff': '#565656',
  'toggle/foreground': '#fffffffa',
  'toggle/foregroundDisable': '#929292',
  'tooltips/background': '#414141',
  'tooltips/foreground': '#ffffff',
  'tooltips/secondaryBackground': '#ffffff2b',
  'workspacePicker/border': '#414141',
  'workspacePicker/secondaryBackground': '#9292922b',
  'tableOfContent/background': '#252525',
};
